import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { ID_PERFIL_ADMIN_EBP, ID_PERFIL_ADMIN_EMPRESA, TYC_ACEPTADO } from '../constants/perfiles'
import { toastErrorLog } from '../helpers/toastErrorLog'
import { useAuth } from '../hooks/useAuth'
import ContenedorMenu from './ContenedorMenu'
import ContenedorPrincipal from './ContenedorPrincipal'
import withEsMovil from './hoc/withEsMovil'
import * as usuarioService from './servicios/usuarioService'
import { ModalTerminos } from './terminos/ModalTerminos'

const Cuerpo = ({ mostrarAyuda, cambiarImagenPerfil }) => {
  const location = useLocation()

  const {
    isAuthenticated,
    cargandoUsuario,
    loginDataContext: { idPerfil, aceptaTyC, idUsuario, esPrimerAcceso } = {},
    updateUserData,
    finalizarBienvenida
  } = useAuth()

  const debeAceptarTerminos =
    isAuthenticated &&
    !cargandoUsuario &&
    idPerfil !== null &&
    idPerfil !== ID_PERFIL_ADMIN_EBP &&
    aceptaTyC !== TYC_ACEPTADO

  const debeVerModal =
    isAuthenticated && !cargandoUsuario && (debeAceptarTerminos || !!esPrimerAcceso)

  const esAdmin = idPerfil === ID_PERFIL_ADMIN_EMPRESA

  const aceptarTerminos = async () => {
    try {
      await usuarioService.aceptarTerminos(idUsuario)
      updateUserData({ aceptaTyC: TYC_ACEPTADO })
      finalizarBienvenida()
    } catch (error) {
      const mensaje = 'Ocurrió un error al aceptar los Términos y Condiciones.'
      toastErrorLog(error, mensaje, 'usuario')
    }
  }
  return (
    <>
      {location.pathname.indexOf('Login') === -1 && isAuthenticated && (
        <div>
          <ModalTerminos
            show={debeVerModal}
            esAdmin={esAdmin}
            esPrimerAcceso={!!esPrimerAcceso}
            debeAceptarTerminos={debeAceptarTerminos}
            onAceptar={aceptarTerminos}
            onContinuar={finalizarBienvenida}
          />
          <ContenedorMenu mostrarAyuda={mostrarAyuda} />
        </div>
      )}
      {
        <div
          className="main-content-container"
          style={{
            boxSizing: 'border-box', // Include padding in width calculation
            maxWidth: '100%', // Ensure it never exceeds viewport width
            width: '100vw'
          }}
        >
          <ContenedorPrincipal cambiarImagenPerfil={cambiarImagenPerfil} />
        </div>
      }
    </>
  )
}

Cuerpo.propTypes = {
  mostrarAyuda: PropTypes.func,
  cambiarImagenPerfil: PropTypes.func
}

export default withEsMovil(Cuerpo)
